// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"4c66f799","977":"c436f436"}[chunkId] + ".chunk.js";
};